import React from 'react';
import {RoleGuard} from "../../components/PermissionGuard";
import {CaseManagementFeature} from "../../features/caseManagement";

const ALLOWED_ROLES = ['god', 'admin', 'worker']

const CaseManagementPage = ({
  userToken,
  userRole,
}) => (
  <RoleGuard
    role={userRole}
    userToken={userToken}
    allowedRoles={ALLOWED_ROLES}
  >
    <CaseManagementFeature
      userToken={userToken}
      userRole={userRole}
    />
  </RoleGuard>
);

export default CaseManagementPage;
